<template>
  <el-card class="panel">
    <slot></slot>
  </el-card>
</template>

<script>
export default {
  name: 'Panel'
}
</script>

<style scoped>
.panel {
  border: 1px solid #dbdee7;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
</style>



// WEBPACK FOOTER //
// src/common/components/Panel.vue